// Real backend API client
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const createEntity = (entityName, endpoint) => ({
  create: async (data) => {
    const response = await axios.post(`${API}/${endpoint}`, data);
    return response.data;
  },
  
  list: async (orderBy = '-created_date', limit = 200) => {
    const response = await axios.get(`${API}/${endpoint}`, {
      params: { limit }
    });
    return response.data;
  },
  
  filter: async (criteria) => {
    const response = await axios.get(`${API}/${endpoint}`, {
      params: criteria
    });
    return response.data;
  },
});

export const base44 = {
  entities: {
    Answer: createEntity('Answer', 'answers'),
    Suggestion: createEntity('Suggestion', 'suggestions'),
    HangmanPlayer: createEntity('HangmanPlayer', 'hangman-players'),
  },
};
